export const LOCALE = [
  "cz",
  "ge",
  "ne",
  "it",
  "de_CH",
  "en_AU_ocker",
  "ja",
  "ar",
  "en_CA",
  "pt_BR",
  "de",
  "es",
  "vi",
  "hr",
  "en_ZA",
  "fr",
  "id_ID",
  "nb_NO",
  "zh_TW",
  "ro",
  "pl",
  "en_GB",
  "en_AU",
  "fr_CA",
  "hy",
  "ko",
  "en_BORK",
  "es_MX",
  "en_IE",
  "az",
  "nl_BE",
  "en_US",
  "sk",
  "fr_CH",
  "en_IND",
  "sv",
  "fi",
  "en",
  "zh_CN",
  "he",
  "pt_PT",
  "de_AT",
];
